import { render, staticRenderFns } from "./AddPrivateModal.vue?vue&type=template&id=02d9298c&"
import script from "./AddPrivateModal.vue?vue&type=script&lang=js&"
export * from "./AddPrivateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports